import React, { Component } from 'react';
import './view.css';
import ProThumb from '../projects/proThumb.js';




class View extends Component {
    constructor(){
        super();
        this.iCount = 0;
        this.images=[]
        this.timer = null;
        this.mapRef=null;
        this.currTop = 0;
        this.currLeft = 0;
        this.state = {
            data:[],
            cx: 0,
            cy:0,
            menu: false,
            depth: 3,
            loaded: false
        }

    };





   

    render() {
        const { data } = this.props;
        const {mapActive} =this.props;
        const {win} = this.props;
        const {mPos} = this.props;
        const {mScale} = this.props;
        const {cx} = this.props;
        const {cy} = this.props;
        const {initPro} = this.props;
        const {mobile} = this.props;
        const {loaded} = this.props;
        this.count = 0
     
    return (
     
    
      <React.Fragment>
          
        <div id="mapContain" key={this.props.secondary} className="relative  mapContain" style={{width: mScale*win[0], height: mScale*(win[0]/2),transform:`translate3d(${cx}px,${cy}px,0)`}} ref={element => this.mapRef = element}>
                

                
                {data.length && loaded?(
                    <React.Fragment >

                            {data.map((item,i)=>{
                                  this.count > this.state.depth?(this.count=0):(this.count++)
                                return(
                                    <React.Fragment key={`item-${i}`}>
                                      
                                    
                                        
                                            <ProThumb titleCase={this.props.titleCase}  isMobile={this.props.isMobile} filter={this.props.filter} secondary={this.props.secondary} mobile={mobile} initCrawl={this.props.initCrawl} deCrawl={this.props.deCrawl} hover={this.props.hover} count={this.count} image={this.props.image} item={item} i={i} getImg={this.props.getImg} mScale={mScale} cx={cx} cy={cy} mPos={mPos} mapActive={mapActive} initPro={initPro} win={win}/>
                                        
                                       
                                    </React.Fragment>

                                )
                                
                            })}
                        </React.Fragment>

                    // this.setupVids()
                ):('')}
                

            </div>
                

    
       </React.Fragment>
    
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/components/view/view.js